import { MSSMembers, MSSPhone } from '@lib/types';
import { formatDateToMMDDYYYY, toProperCase } from '../utils/formatters';
import { IMemberDetails } from './model';

export const mapMemberDetailsApiResponseToState = (apiResponse: IMemberDetails): IMemberDetails => {
  try {    
    const { members } = apiResponse;
    return {
      ...apiResponse,
      selectedCustomerId: members?.length === 1 ? members[0].customerId : undefined,
      members: getFormattedMembers(members || []),
    };
  } catch (error) {
    console.error('Error mapping member details API response to state:', error);
    return apiResponse;
  }
};

const getFormattedMembers = (members: MSSMembers[]): MSSMembers[] => {
  return members.map((member) => ({
    ...(member as MSSMembers),
    firstName: toProperCase(member.firstName) || '',
    middleName: toProperCase(member.middleName!) || '',
    lastName: toProperCase(member.lastName) || '',
    phoneNumbers: zeroOutInvalidPhoneNumbers(member.phoneNumbers || []),
  }));
};

const zeroOutInvalidPhoneNumbers = (phoneNumbers: MSSPhone[]) => {
  const zeroValuePhoneNumbers = ['0'.repeat(10), '2'.repeat(10), '3'.repeat(10), '5'.repeat(10)];
  return phoneNumbers?.map((mssPhone) => {
    const rawPhoneNumber = (mssPhone.areaCode || '') + (mssPhone.prefix || '') + (mssPhone.suffix || '');
    const isZeroValuePhoneNumber = zeroValuePhoneNumbers.includes(rawPhoneNumber);

    if (isZeroValuePhoneNumber) {
      return {
        ...mssPhone,
        areaCode: '',
        prefix: '',
        suffix: '',
      };
    }

    return mssPhone;
  });
};
